import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * /shift-monitor — NOW A REDIRECT INTO THE SHIFTS TAB.
 *
 * Owner instruction, 2026-08-11: one Shifts tab for admins and managers, with
 * the live desk and the history in one place. This page WAS the live desk; its
 * three groups now live in <ShiftMonitorPanel> and are mounted by
 * /dashboard/shifts under "On now".
 *
 * ═══════════════ WHY THE ROUTE STAYS INSTEAD OF BEING DELETED ═══════════════
 * It is a real URL people have open in a tab, bookmarked, and pasted into
 * messages. Deleting it turns those into the app's 404 with nothing to act on,
 * which is a worse outcome than one extra redirect for a page that moved. The
 * route's `user:read` gate is unchanged and still runs before this component
 * mounts, so a concierge is bounced by the gate rather than being redirected
 * into a dashboard they cannot open.
 *
 * `replace`, not a push: the monitor is not a step in a journey, and leaving it
 * in the history stack means Back from the Shifts tab lands here and bounces
 * straight forward again — a trap the reader cannot escape with the browser's
 * own control.
 */
export const ShiftMonitorPage: React.FC = () => (
  <Navigate to="/dashboard/shifts" replace />
);
